import {
  getCountryCallingCode,
  isPossiblePhoneNumber,
  isValidPhoneNumber,
} from 'react-phone-number-input';
import { PhoneValue } from '../components/form-controls/PhoneNumberInput';

export const concatPhone = (value: PhoneValue): string => {
  const countryCode =
    value.country && getCountryCallingCode(value.country)
      ? `+${getCountryCallingCode(value.country)}`
      : '';
  return `${countryCode}${value.phoneNumber}`;
};

export const validatePhoneNumber = (value: PhoneValue): boolean => {
  const isValid =
    !!value.phoneNumber &&
    !!value?.country &&
    isPossiblePhoneNumber(concatPhone(value)) &&
    isValidPhoneNumber(concatPhone(value));
  return isValid;
};
